import { render, staticRenderFns } from "./CustomerServices.vue?vue&type=template&id=7410933b&scoped=true&"
import script from "./CustomerServices.vue?vue&type=script&lang=js&"
export * from "./CustomerServices.vue?vue&type=script&lang=js&"
import style0 from "./CustomerServices.vue?vue&type=style&index=0&id=7410933b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7410933b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VIcon,VRow})
